/**
 * SiteUp (M3/M4) — helpers puros do ciclo de vida da mensagem no fio.
 * O backend (v817) já grava revoked_at / edited / original_content;
 * aqui só formatamos o que a bolha desenha.
 */

export function formatClockTime(value) {
  if (value === null || value === undefined || value === '') return '';

  let ms;
  if (typeof value === 'number') {
    // createdAt do Chatwoot vem em segundos Unix; ISO vira Date abaixo.
    ms = value < 1e12 ? value * 1000 : value;
  } else {
    ms = new Date(value).getTime();
  }

  if (Number.isNaN(ms)) return '';

  return new Date(ms).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function isRevokedMessage(attrs = {}) {
  return Boolean(attrs?.revokedAt);
}

export function isEditedMessage(attrs = {}) {
  return Boolean(attrs?.edited);
}

/** 'revoked' | 'edited' | null — revoked ganha se os dois vierem juntos. */
export function lifecycleFilletTone(attrs = {}) {
  if (isRevokedMessage(attrs)) return 'revoked';
  if (isEditedMessage(attrs)) return 'edited';
  return null;
}
